export default __webpack_public_path__ + "static/kb_2_5-82139581332ed825a97e7b8c496a4380.jpeg";